import React from 'react'
import { useTranslation } from 'react-i18next'
import ArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { CalendarEvent } from 'calendar-link'
import useStyles, { PopoverStyles } from './styles'
import MuiButton from '@mui/material/Button'
import MuiPopover from '@mui/material/Popover'
import EventIcon from '@mui/icons-material/Event'
import { CALENDAR_LINKS_CONFIG } from 'src/config/calendarEvents'
import { useIsPhoneOnly } from 'src/config/mediaQueries'
import { TEST_IDS } from 'src/constants/testIds'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

type CalendarButtonProps = {
  event: CalendarEvent
}

export const CalendarButton = ({ event }: CalendarButtonProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const events = Object.values(CALENDAR_LINKS_CONFIG)
  const isPhone = useIsPhoneOnly()
  const buttonSize = isPhone ? 'lg' : 'xl'
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)

  const handleClose = () => setAnchorEl(null)

  const open = Boolean(anchorEl)
  const id = open ? 'popover' : undefined

  return (
    <div className={classes.calendarButtonContainer}>
      <MuiButton
        aria-describedby={id}
        onClick={handleClick}
        startIcon={<EventIcon />}
        endIcon={open ? <ArrowUpIcon /> : <ArrowDownIcon />}
        size={buttonSize}
        className={classes.calendarButton}
        data-test={TEST_IDS.addToCalendarButton}
        variant="bordered"
      >
        {t('add_to_calendar_button')}
      </MuiButton>

      <MuiPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={PopoverStyles}
      >
        <List>
          {events.map(({ icon, dropdownLabel, link }) => {
            const source = link(event)

            return (
              <ListItemButton
                key={dropdownLabel}
                component="a"
                target="_blank"
                download="your_appointment"
                href={source}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText>{dropdownLabel}</ListItemText>
              </ListItemButton>
            )
          })}
        </List>
      </MuiPopover>
    </div>
  )
}
